import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { ReceptionVm } from './reception.vm';
import { Type } from 'class-transformer';

export class GetReceptionsVm extends PageResponseVm<ReceptionVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => ReceptionVm)
  @ValidateNested({ each: true })
  objects: ReceptionVm[];
}
